import { createApp } from "vue";
import NavComponent from "./NavComponent.vue";

const app = createApp({
  components: {
    "nav-component": NavComponent,
  },
}).mount("#container-nav-component");
